import React from "react";
import styled from "styled-components";
import { format } from "date-fns";
import { ko } from "date-fns/locale";

// 시간 포맷 함수
const formatPGTime = (timeString) => {
  const date = new Date(timeString);
  return format(date, "yyyy-MM-dd HH:mm:ss", { locale: ko });
};

// 스타일드 컴포넌트 정의
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

const Th = styled.th`
  background-color: #007bff;
  color: white;
  padding: 12px 8px;
  text-align: left;
  border: 1px solid #ddd;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
`;

const Row = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }

  &:hover {
    background-color: #e9ecef;
  }
`;

const NoDataMessage = styled.p`
  font-size: 16px;
  color: #555;
  margin: 20px 0;
  text-align: center;
`;

// BidsInfo 컴포넌트 정의
export default function BidsInfo({ bidInfo }) {
  if (!bidInfo || (Array.isArray(bidInfo) && bidInfo.length === 0)) {
    return <NoDataMessage>입찰 정보가 없습니다.</NoDataMessage>;
  }

  if (bidInfo.error) {
    return <NoDataMessage>{bidInfo.error}</NoDataMessage>;
  }

  return (
    <Table>
      <thead>
        <tr>
          <Th>경매번호</Th>
          <Th>입찰번호</Th>
          <Th>금액</Th>
          <Th>경매자ID</Th>
          <Th>입찰시간</Th>
        </tr>
      </thead>
      <tbody>
        {bidInfo.map((bid, index) => (
          <Row key={index}>
            <Td>{bid.public_order_id}</Td>
            <Td>{bid.menu_id}</Td>
            <Td>{bid.bid_amount}</Td>
            <Td>{bid.agent_id}</Td>
            <Td>{formatPGTime(bid.created_at)}</Td>
          </Row>
        ))}
      </tbody>
    </Table>
  );
}